(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_l-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
        function initReviewsSliders() {
            if (typeof Swiper === 'undefined') return false;

            document.querySelectorAll('.reviews__slider:not(.swiper-initialized)').forEach((slider) => {
                new Swiper(slider, {
                    slidesPerView: 'auto',
                    loop: true,
                    // Without this Swiper locks itself on small slide counts and the
                    // theme hides the locked arrows, but the design always shows them.
                    watchOverflow: false,
                    spaceBetween: 16,
                    breakpoints: {
                        768: {
                            spaceBetween: 40,
                        },
                    },
                    pagination: {
                        el: slider.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        nextEl: slider.querySelector('.carousel__btn-next'),
                        prevEl: slider.querySelector('.carousel__btn-prev'),
                    },
                });
            });

            return true;
        }

        if (!initReviewsSliders()) {
            window.addEventListener('load', initReviewsSliders);
        }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["club-tiers"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.club-tiers__slider:not(.swiper-initialized)').forEach((slider) => {
        const swiper = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 16,
            centeredSlides: true,
            initialSlide: 1,
            navigation: {
                nextEl: slider.querySelector('.club-tiers__button--next'),
                prevEl: slider.querySelector('.club-tiers__button--prev'),
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    });

    document.querySelectorAll('.club-tiers__features').forEach((el) => {
    el.innerHTML = el.innerHTML.replace(
        /(\$[\d,]+(?:\.\d{2})?)/g,
        '<s><em>$1</em></s>'
    );
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["flavors"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.flavors-block__slider:not(.swiper-initialized)').forEach((slider) => {
        const swiper = new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            spaceBetween: 0,
            grabCursor: true,
            allowTouchMove: true,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                }
            },
            pagination: {
                el: slider.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.flavors-block__button--next'),
                prevEl: slider.querySelector('.flavors-block__button--prev'),
            },
        });

        slider.querySelectorAll('.flavors-block__button--prev-2').forEach((button) => {
            button.addEventListener('click', () => {
                swiper.slidePrev();
            });
        });

        slider.querySelectorAll('.flavors-block__button--next-2').forEach((button) => {
            button.addEventListener('click', () => {
                swiper.slideNext();
            });
        });
    });
  } catch(e) { console.error(e); }
})();

})();
